export default "__VITE_ASSET__a0804f20__"